import { Button, CopyButton, Flex, NativeSelect } from '@mantine/core';
import {
  IconArchive,
  IconArchiveOff,
  IconCheck,
  IconCopy,
  IconFilePlus,
  IconFolderOpen,
  IconTrash,
} from '@tabler/icons-react';
import { useIntl } from 'react-intl';
import { Folder } from '../types';
import routes from '@/commons/routes';

interface FolderActionsProps {
  folder: Folder;
  onAddFile: () => void;
  onOpen: () => void;
  onArchive: () => void;
  onStatusChange: (status: string) => void;
  onDelete: () => void;
}

export const FolderActions = ({
  folder,
  onAddFile,
  onOpen,
  onArchive,
  onStatusChange,
  onDelete,
}: FolderActionsProps) => {
  const intl = useIntl();

  return (
    <Flex direction="row" gap="xs" justify="space-between">
      <Flex direction="row" gap="xs" align="center">
        <Button
          id={`add-annex-button-${folder.folderName}`}
          size="xs"
          variant="light"
          color="green"
          leftSection={<IconFilePlus size={16} />}
          onClick={onAddFile}
        >
          {intl.formatMessage({ id: 'addFile' })}
        </Button>
      </Flex>
      <Flex align="center" gap="xs">
        <Button
          id={`user-view-button-${folder.folderName}`}
          size="xs"
          variant="default"
          leftSection={<IconFolderOpen size={16} />}
          onClick={onOpen}
        >
          {intl.formatMessage({ id: 'clientFolder' })}
        </Button>
        <CopyButton
          value={`${window.location.origin}${routes.routes.clientFolder(folder.folderName)}\n${intl.formatMessage({ id: 'password' })}: ${folder.password}`}
        >
          {({ copied, copy }) => (
            <Button
              id={`copy-password-button-${folder.folderName}`}
              size="xs"
              variant={copied ? 'outline' : 'default'}
              leftSection={
                copied ? <IconCheck size={16} /> : <IconCopy size={16} />
              }
              color={copied ? 'green' : 'blue'}
              onClick={copy}
            >
              {intl.formatMessage({ id: 'linkAndPassword' })}
            </Button>
          )}
        </CopyButton>
        <Button
          id={`archive-button-${folder.folderName}`}
          size="xs"
          variant="default"
          leftSection={
            folder.isArchived ? (
              <IconArchiveOff size={16} />
            ) : (
              <IconArchive size={16} />
            )
          }
          onClick={onArchive}
        >
          {folder.isArchived
            ? intl.formatMessage({ id: 'unarchive' })
            : intl.formatMessage({ id: 'archive' })}
        </Button>
        <Button
          id={`delete-folder-button-${folder.folderName}`}
          size="xs"
          color="red"
          variant="light"
          leftSection={<IconTrash size={16} />}
          onClick={onDelete}
        >
          {intl.formatMessage({ id: 'delete' })}
        </Button>
        <NativeSelect
          size="xs"
          value={folder.backOfficeStatus?.toString()}
          onChange={(event) => onStatusChange(event.target.value)}
          data={[
            { value: '-1', label: intl.formatMessage({ id: 'noStatus' }) },
            {
              value: '3',
              label: intl.formatMessage({ id: 'inProgress' }),
            },
            {
              value: '4',
              label: intl.formatMessage({ id: 'finalized' }),
            },
          ]}
        />
      </Flex>
    </Flex>
  );
};
